import { doctrineAnalytics } from '../utils/analyticsUtils';

export function quoteClicked(author: string) {
  doctrineAnalytics('Home InterviewsQuotesClicked', {
    type: 'interview',
    author,
  });
}
